"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocaleService = void 0;
var url_join_1 = __importDefault(require("url-join"));
var convert_1 = require("./convert");
var Urls = {
    getLanguage: '/user-service/account-settings/setting/language',
    putLanguage: '/user-service/account-settings/setting/language',
};
// ref: https://confluence.zhihuiya.com/display/~zhanggang/User+Service+Design+And+APIs#
var LocaleService = /** @class */ (function () {
    function LocaleService(transfer, baseUrl, loginIn, disableHttpCache) {
        this.transfer = transfer;
        this.baseUrl = baseUrl;
        this.loginIn = loginIn;
        this.disableHttpCache = disableHttpCache;
    }
    Object.defineProperty(LocaleService.prototype, "LoginIn", {
        set: function (value) {
            this.loginIn = value;
        },
        enumerable: false,
        configurable: true
    });
    LocaleService.prototype.fetchLocale = function () {
        if (!this.loginIn) {
            return Promise.resolve(undefined);
        }
        var url = this._J(Urls.getLanguage);
        return this.transfer.get(url, __assign({ withCredentials: false }, this.ExtendsParams)).then(function (data) {
            return convert_1.normalizeLang(data.data.language);
        });
    };
    LocaleService.prototype.pushLocale = function (locale) {
        if (!this.loginIn) {
            return Promise.resolve(undefined);
        }
        var url = this._J(Urls.putLanguage);
        var data = {
            language: convert_1.toServerLocale(locale)
        };
        return this.transfer.put(url, data, __assign({ withCredentials: false, headers: {
                'Content-Type': 'application/json'
            } }, this.ExtendsParams));
    };
    Object.defineProperty(LocaleService.prototype, "ExtendsParams", {
        get: function () {
            return {
                cache: !this.disableHttpCache
            };
        },
        enumerable: false,
        configurable: true
    });
    LocaleService.prototype._J = function (path) {
        return url_join_1.default(this.baseUrl, path);
    };
    return LocaleService;
}());
exports.LocaleService = LocaleService;
//# sourceMappingURL=service.js.map